import { extendTheme } from '@chakra-ui/react';

export const baseTheme = extendTheme({
  colors: {
    norm: {
      black: '#000000',
      normBlack: '#17181C',
      normWhite: '#FBFBFB',
      whiteAlpha: {
        50: 'rgba(255, 255, 255, 0.04)',
        100: 'rgba(255, 255, 255, 0.06)',
        200: 'rgba(255, 255, 255, 0.08)',
        300: 'rgba(255, 255, 255, 0.16)',
        400: 'rgba(255, 255, 255, 0.24)',
        500: 'rgba(255, 255, 255, 0.36)',
        600: 'rgba(255, 255, 255, 0.48)',
        700: 'rgba(255, 255, 255, 0.64)',
        800: 'rgba(255, 255, 255, 0.80)',
        900: 'rgba(255, 255, 255, 0.92)',
      },
      blackAlpha: {
        50: 'rgba(0, 0, 0, 0.04)',
        100: 'rgba(0, 0, 0, 0.06)',
        200: 'rgba(0, 0, 0, 0.08)',
        300: 'rgba(0, 0, 0, 0.16)',
        400: 'rgba(0, 0, 0, 0.24)',
        500: 'rgba(0, 0, 0, 0.36)',
        600: 'rgba(0, 0, 0, 0.48)',
        700: 'rgba(0, 0, 0, 0.64)',
        800: 'rgba(0, 0, 0, 0.80)',
        900: 'rgba(0, 0, 0, 0.92)',
      },
      gray: {
        50: '#F0F0F3',
        100: '#E5E6EA',
        200: '#DADCE1',
        300: '#BABDC6',
        400: '#A5A8B5',
        500: '#8F93A3',
        600: '#5E6272',
        700: '#32343C',
        800: '#292A32', // 800 and 900 are the same
        900: '#292A32', // 800 and 900 are the same
      },
      orange: {
        50: '#FFFAF0',
        100: '#FEEBCB',
        200: '#FBD38D',
        300: '#F6AD55',
        400: '#ED8936',
        500: '#DD6B20',
        600: '#C05621',
        700: '#9C4221',
        800: '#7B341E',
        900: '#652B19',
      },
      red: {
        50: '#FFEEEB',
        100: '#FFDED7',
        200: '#FFBFB0',
        300: '#FF9F89',
        400: '#FF4F26',
        500: '#FE2F00',
        600: '#D72800',
        700: '#B02100',
        800: '#891900',
        900: '#611200',
      },
      yellow: {
        50: '#FFF9EB',
        100: '#FFF3D7',
        200: '#FFE6B0',
        300: '#FFDA89',
        400: '#FFC84E',
        500: '#FEAF00',
        600: '#D79400',
        700: '#975A16',
        800: '#895E00',
        900: '#4E3500',
      },
      green: {
        50: '#EBFFF4',
        100: '#D7FFE8',
        200: '#B0FFD2',
        300: '#9CFFC7',
        400: '#00FE6F',
        500: '#00D75E',
        600: '#00B04D',
        700: '#00893C',
        800: '#00612B',
        900: '#003A19',
      },
      teal: {
        50: '#DFFCF6',
        100: '#A9F7E8',
        200: '#85F4DE',
        300: '#61F0D5',
        400: '#19EAC2',
        500: '#13C9A6',
        600: '#11B797',
        700: '#0E937A',
        800: '#074C3E',
        900: '#042821',
      },
      blue: {
        50: '#EEEBFF',
        100: '#CEC3FF',
        200: '#AF9CFF',
        300: '#6F4EFF',
        400: '#3F13FF',
        500: '#2800D7',
        600: '#2100B0',
        700: '#190089',
        800: '#120061',
        900: '#0B003A',
      },
      purple: {
        50: '#F9EBFF',
        100: '#F3D7FF',
        200: '#E6B0FF',
        300: '#D475FF',
        400: '#C23AFF',
        500: '#AF00FE',
        600: '#9400D7',
        700: '#7900B0',
        800: '#5E0089',
        900: '#430061',
      },
    },
  },
});
